var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelPinterestSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12,
  viewBox: "0 0 10 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.926 0C1.651 0 0 2.348 0 4.306c0 1.185.449 2.24 1.412 2.633.157.065.299.002.345-.172l.14-.554c.046-.173.029-.233-.099-.384-.277-.327-.455-.751-.455-1.352 0-1.741 1.303-3.3 3.394-3.3 1.85 0 2.868 1.13 2.868 2.64 0 1.988-.88 3.665-2.185 3.665-.721 0-1.261-.596-1.088-1.327.207-.873.608-1.816.608-2.446 0-.564-.303-1.035-.93-1.035-.737 0-1.329.763-1.329 1.784 0 .65.22 1.09.22 1.09l-.886 3.757c-.264 1.115-.04 2.481-.021 2.62.011.081.116.1.164.039.068-.09.946-1.173 1.244-2.256.085-.307.485-1.895.485-1.895.24.457.94.86 1.684.86 2.215 0 3.719-2.02 3.719-4.724C9.29 1.904 7.558 0 4.926 0"
})));
export default SvgChannelPinterestSm;